export function isImage(filename) {
  return /\.(gif|jpg|jpeg|tiff|png)$/i.test(filename);
}

export function isVideo(filename) {
  return /\.(avi|flv|wmv|mov|mp4)$/i.test(filename);
}
